import { ENVIRONMENT_NAME } from '@/configs/environment';

export const isLocal = (): boolean => {
  return process.env.NAME === ENVIRONMENT_NAME.LOCAL;
};
